{
    "en": [
        {
            "key": "user-management-page",
            "title": "New User Management Page",
            "shortDescription": "Search all org users and create roles directly in the panel.",
            "description": "A dedicated User Management page has been introduced. Company admins/managers can search and view all users in an organization and create Agents, Team Leaders, and Managers directly from the same panel.",
            "image": "/assets/whats-new/user-management-page.jpg",
            "date": "2025-11-01"
        },
        {
            "key": "user-export-and-import",
            "title": "User Export & Import",
            "shortDescription": "Export users to CSV and bulk import new users with guided mapping and validation.",
            "description": "User Management now supports full user list export to CSV for quick audits, sharing, and bulk edits in spreadsheets. Additionally, a new User Import flow lets admins add large batches of users via copy-paste from spreadsheets or file import. During import, you can map incoming columns to i2x fields and the system validates data in real time, highlighting issues like missing values, invalid roles, or duplicates so you can fix them before finalizing.",
            "image": "/assets/whats-new/user-export-import.jpg",
            "date": "2025-12-14"
        },
        {
            "key": "calls-dashboard",
            "title": "Calls Dashboard: customizable call panels",
            "shortDescription": "Build your own call overview with filter-based panels and quick reordering.",
            "description": "A new Calls Dashboard is available to help you stay on top of recent activity. Add panels based on saved call filters, view the latest calls in a compact table, and keep the layout tidy by moving panels up/down or removing ones you don’t need. Click any row to open the call details in a new tab for faster deep-dives.",
            "image": "/assets/whats-new/calls-dashboard.jpg",
            "date": "2026-02-09"
        },
        {
            "key": "live-dashboard-today",
            "title": "Live Dashboard: Today view is here",
            "shortDescription": "Track today’s performance in real time with team KPIs and agent rankings.",
            "description": "The Live Dashboard now includes a dedicated “Today” view so you can monitor performance as the day unfolds. See key team totals (like total calls and average calls per agent), and review agent rankings with clear status indicators to quickly spot who’s on target, unstable, or critical.",
            "image": "/assets/whats-new/live-dashboard-today.jpg",
            "date": "2026-02-12",
            "appConfigDependencyKey": "liveDashboardEnabled"
        }
    ],
    "de": [
        {
            "key": "user-management-page",
            "title": "Neue Benutzerverwaltungsseite",
            "shortDescription": "Alle Organisationsnutzer durchsuchen und Rollen direkt im Panel anlegen.",
            "description": "Eine eigene Seite für die Benutzerverwaltung wurde eingeführt. Company Admins/Manager können alle Nutzer einer Organisation suchen und ansehen sowie Agents, Team Leaders und Manager direkt im selben Panel erstellen.",
            "image": "/assets/whats-new/user-management-page.jpg",
            "date": "2025-11-01"
        },
        {
            "key": "user-export-and-import",
            "title": "Benutzer-Export & -Import",
            "shortDescription": "Benutzer als CSV exportieren und neue Nutzer per Bulk-Import mit Mapping und Validierung hinzufügen.",
            "description": "Die Benutzerverwaltung unterstützt jetzt den Export der vollständigen Benutzerliste als CSV für schnelle Audits, Weitergabe und Massenbearbeitungen in Tabellen. Zusätzlich ermöglicht ein neuer Benutzer-Import, große Nutzer-Stapel per Copy-Paste aus Tabellen oder per Datei-Import hinzuzufügen. Während des Imports können Spalten auf i2x-Felder gemappt werden; das System prüft die Daten in Echtzeit und markiert Probleme wie fehlende Werte, ungültige Rollen oder Duplikate, sodass Fehler vor dem Abschluss direkt behoben werden können.",
            "image": "/assets/whats-new/user-export-import.jpg",
            "date": "2025-12-14"
        },
        {
            "key": "live-agent-panel",
            "title": "Echtzeit-Agentenaktivität auf einen Blick",
            "shortDescription": "Verschaffen Sie sich einen schnellen Überblick über die Agentenaktivität mit unserem neuen Live Agents Panel.",
            "description": "Bleiben Sie auf dem Laufenden mit unserem neuen Live Agents Panel! Überwachen Sie die Verfügbarkeit von Agenten in Echtzeit, einschließlich aktueller Status wie 'Eingeloggt' oder 'Im Gespräch', und sehen Sie genau, wie viel Zeit seit ihrer letzten Aktivität vergangen ist.",
            "image": "/assets/whats-new/agent-panel.jpg",
            "date": "2026-01-07"
        },
        {
            "key": "calls-dashboard",
            "title": "Calls Dashboard: flexible Call-Panels",
            "shortDescription": "Erstellen Sie Ihren eigenen Call-Überblick mit Filter-Panels und schneller Sortierung.",
            "description": "Ein neues Calls Dashboard hilft Ihnen, aktuelle Aktivitäten schnell zu überblicken. Fügen Sie Panels auf Basis gespeicherter Call-Filter hinzu, sehen Sie die neuesten Calls in einer kompakten Tabelle und halten Sie Ihr Layout übersichtlich, indem Sie Panels nach oben/unten verschieben oder nicht benötigte entfernen. Mit einem Klick auf eine Zeile öffnen Sie die Call-Details in einem neuen Tab – ideal für schnelle Deep-Dives.",
            "image": "/assets/whats-new/calls-dashboard.jpg",
            "date": "2026-02-09"
        },
        {
            "key": "live-dashboard-today",
            "title": "Live Dashboard: Heute-Ansicht ist da",
            "shortDescription": "Verfolgen Sie die Performance von heute in Echtzeit – mit Team-KPIs und Agent-Ranking.",
            "description": "Das Live Dashboard enthält jetzt eine eigene „Heute“-Ansicht, damit Sie die Performance im Tagesverlauf live im Blick behalten. Sehen Sie zentrale Team-Kennzahlen (z. B. Gesamtanzahl Calls und durchschnittliche Calls pro Agent) und ein Agent-Ranking mit klaren Status-Indikatoren, um schnell zu erkennen, wer im grünen Bereich ist, instabil wird oder kritisch ist.",
            "image": "/assets/whats-new/live-dashboard-today.jpg",
            "date": "2026-02-12",
            "appConfigDependencyKey": "liveDashboardEnabled"
        }
    ]
}
